import { render, staticRenderFns } from "./privateAssets.vue?vue&type=template&id=68918c2b&scoped=true"
import script from "./privateAssets.vue?vue&type=script&lang=js"
export * from "./privateAssets.vue?vue&type=script&lang=js"
import style0 from "./privateAssets.vue?vue&type=style&index=0&id=68918c2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68918c2b",
  null
  
)

export default component.exports